import { dispatch } from 'nike-re-framejs';
import PopupNg from '@/ui/PopupNg';
import { fetchTicket } from '../detail/api';
import { getGrid, submitStorno } from './api';
import { changeTicketusActiveMark } from '@/mytickets/active/handlers';

export const ticketStornoOpen = (hash, ticketNumber, branchId) => db => {
    getGrid();
    return db
        .setIn(['ticketus', 'storno', 'state'], 'opening')
        .setIn(['ticketus', 'storno', 'data'], { hash, ticketNumber, branchId })
        .update(PopupNg.updater.open('ticket/storno'));
};

export const ticketStornoClose = db => db.removeIn(['ticketus', 'storno']).update(PopupNg.updater.close());

export const ticketStornoOpened = gridPosition => db =>
    db.setIn(['ticketus', 'storno', 'gridPosition'], gridPosition).setIn(['ticketus', 'storno', 'state'], 'ready');

export const ticketStornoSubmit = gridChallenge => db => {
    const { hash, ticketNumber, branchId } = db.getIn(['ticketus', 'storno', 'data']);
    submitStorno(ticketNumber, branchId, gridChallenge, hash);
    return db.setIn(['ticketus', 'storno', 'state'], 'submitting');
};

export const ticketStornoSubmited = hash => db => {
    setTimeout(() => {
        fetchTicket(hash);
        dispatch(changeTicketusActiveMark);
    }, 1000);
    return db.update(PopupNg.updater.show('osobnazona.sprava.stornotiketu.telo'));
};
